/**=========================================================
 * Module: app-spinner.js
 * Spinner
 =========================================================*/

App.directive('appSpinner', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/spinner.html',
      restrict: 'E',
      replace: true,
      scope: {
        color: '@color',
        size: '@size',
        margin: '@margin',
        display: '@display'
      }
  };

});